/**
 * A lista de pacotes de demonstração da SAP que o projeto declara (#1072; na conexão de origem
 * até a #1785).
 *
 * Aceita um por linha, vírgula, ponto e vírgula ou espaço, porque a lista
 * costuma vir colada de planilha ou de e-mail. Pacote fora do namespace do
 * cliente (Z, Y ou /) volta separado: a regra de autoria o excluiria de
 * qualquer forma, e o servidor também o recusa.
 */
const CUSTOMER_PREFIXES = ["Z", "Y", "/"];

/**
 * A curadoria do IDES: os pacotes que a caixa "Usar dados de demonstração"
 * carrega no projeto. O motivo de cada um está em
 * docs/ops/ides-curadoria/pacotes.csv, e um teste amarra as duas listas.
 */
export const IDES_DEMO_PACKAGES = [
  "ZPK_9000001286",
  "ZCM_LINKAGE_FRAMEWORK",
  "ZPK_DBR46054",
  "ZPKG_C5240171",
  "ZI_STK",
  "ZSUST_TRANSLATION",
  "ZHCM_TRANSLATION",
  "Z_ADMSTFHR",
  "ZZ_JOBVIPER_INTEGRATION",
  "ZXMII_MONITORING_SERVER",
  "ZPH_ENH",
  "ZIDE",
  "Z_TRANSLATION",
  "Z_I036932",
  "Z_FI_UTILITIES",
  "ZTSS_EU178",
  "ZC2F_DEMO",
  "ZHR306",
  "ZRCO",
  "ZPS0",
  "ZIDI",
] as const;

export function parseDemoPackages(text: string): { packages: string[]; invalid: string[] } {
  const packages: string[] = [];
  const invalid: string[] = [];
  for (const raw of text.split(/[\s,;]+/)) {
    const name = raw.trim().toUpperCase();
    if (!name) continue;
    const target = CUSTOMER_PREFIXES.some((p) => name.startsWith(p)) ? packages : invalid;
    if (!target.includes(name)) target.push(name);
  }
  return { packages, invalid };
}
